import React, {Component} from 'react'
import styles from './FJRecordFromModal.module.less';
import FJLocalStore from "../../../store/FJLocalStore";
import FJButton from "fj-components/FJButton";
import screenSvg from '../../../icon/model-screen.svg';
import webCamSvg from '../../../icon/modal-webcam.svg';
import InlineSVG from "react-inlinesvg"
import classNames from 'classnames'

function RecordFromPanel(props) {
  let {
    onClick,
    text,
    icon,
    className,
    active
  } = props;

  let cn = classNames(styles.record_from, active ? styles.active : '');

  return (
    <div onClick={onClick} className={cn}>
      <InlineSVG src={icon} className={className} element='div' />
      <div className={styles.text}>{text}</div>
    </div>
  );
}


class FJRecordFromModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      chooseRecordType: 0
    };
  }

  /**
   * @description 初始化数据
   */
  initData = () => {
    this.setState({
      chooseRecordType: 0
    });
  };

  /**
   * @description 设置当前选中
   * @param value
   * @private
   */
  _choose = (value) => {
    this.setState({
      chooseRecordType: value
    });
  };

  /**
   * @description 确认选择
   * @private
   */
  _onSubmit = () => {
    let {chooseRecordType} = this.state;
    if (chooseRecordType === 0) {
      return
    } else if (chooseRecordType === 1) { // 录屏
      this.props.screenClick();
    } else if (chooseRecordType === 2) { // 录像
      this.props.webCamClick();
    }
    this.initData()
  };

  render() {
    let {chooseRecordType} = this.state;

    return (
      <div className={styles.box}>
        <div className={styles.content}>
          <RecordFromPanel text={FJLocalStore._('screen')}
                           icon={screenSvg}
                           active={chooseRecordType === 1}
                           onClick={() => { this._choose(1)}}
          />
          <RecordFromPanel text={FJLocalStore._('web-cam')}
                           icon={webCamSvg}
                           active={chooseRecordType === 2}
                           onClick={() => { this._choose(2)}}
          />
        </div>
        <div className={styles.footer}>
          <FJButton className={styles.btn} disabled={chooseRecordType === 0} text={FJLocalStore._('next')} onClick={this._onSubmit} />
        </div>
      </div>
    );
  }
}


export default FJRecordFromModal;
